import PaypalButton from './PaypalButton'

export default PaypalButton
